export const isGoogleReferrer = (
  referrer: string = typeof document !== "undefined" ? document.referrer : "",
): boolean => {
  if (!referrer) return false;
  try {
    return /(^|\.)google\./i.test(new URL(referrer).hostname);
  } catch {
    return false;
  }
};

export const isGoogleUtmSource = (
  search: string = typeof window !== "undefined" ? window.location.search : "",
): boolean => {
  try {
    return (
      new URLSearchParams(search).get("utm_source")?.toLowerCase() === "google"
    );
  } catch {
    return false;
  }
};

export const cameFromGoogle = (referrer?: string, search?: string): boolean =>
  isGoogleReferrer(referrer) || isGoogleUtmSource(search);
